import { camelCaseToCapitalCase } from "../utils/camelCase";

export default function InputDropdown({name, value, onChange, className, items, inputRef, disabled, required}){

    return (
        <select 
            name={name} 
            id={name} 
            value={value} 
            onChange={onChange} 
            className={`form-input ${className || ''}`} 
            ref={inputRef} 
            disabled={disabled} 
            required={required}
        >
            {items && Object.keys(items).filter(key=>items.hasOwnProperty(key)).map(key=>(
                <option value={items[key]}>{camelCaseToCapitalCase(key)}</option>
            ))}
        </select>
    )
}